import { Slugs } from 'common/urls/Slugs';
import React from 'react';
import { useMealPlanSurfacingLogic } from 'src/pages/consumer/meal-plans/hooks/useMealPlanSurfacingLogic';
import { Shef } from 'src/shared/design-system/Icon/Shef';
import { TrackedNavLink } from 'src/shared/design-system/TrackedNavLink';
import { Routes } from 'src/shared/Routes';
import { getSluggedPath } from 'src/shared/utils/RouteUtilities';
import { useCachedZipCode } from 'src/user-preferences/useCachedZipCode';
import { useMealPlanForUserStoreSelectors } from 'src/ztore/wss/meal-plan-for-user-store';
import styled from 'styled-components';
import { match, P } from 'ts-pattern';
import { Colors } from 'web-common/src/shared/styles';

export type LogoProps = {
  color?: string;
  height?: string;
};

const StyledNavLink = styled(TrackedNavLink)<{ color: string }>`
  color: ${({ color }) => color} !important;
  display: flex;
  align-items: center;
`;

const NoLinkWrapper = styled.div<{ color: string }>`
  color: ${({ color }) => color} !important;
  display: flex;
  align-items: center;
`;

export const ShefLogo: React.FC<LogoProps> = ({ height = '24px', color = Colors.RADISH }) => {
  const { shefLogoDisabled, getMealPlanUrl, mealPlanHasBeenRedirected, setMealPlanHasBeenRedirected } =
    useMealPlanSurfacingLogic();
  const userHasActiveMealPlan = useMealPlanForUserStoreSelectors.use.userHasActiveMealPlan();

  const [zipCode] = useCachedZipCode();
  const mealPlanUrl = getMealPlanUrl({});

  const onClick = () => {
    if (mealPlanUrl?.includes(Routes.CONSUMER_MEAL_PLANS_PREFERENCES)) {
      setMealPlanHasBeenRedirected();
    }
  };

  const logoUrl = match({ mealPlanUrl, userHasActiveMealPlan, mealPlanHasBeenRedirected, zipCode })
    .with({ userHasActiveMealPlan: true }, () => Routes.CONSUMER_MEAL_PLANS_UPCOMING_ORDER)
    .with({ mealPlanUrl: P.when((val) => val?.length), mealPlanHasBeenRedirected: false }, () => mealPlanUrl)
    .with({ zipCode: P.string }, () =>
      getSluggedPath(Routes.CONSUMER_EXPLORE, [{ slug: Slugs.ZIP_CODE, value: zipCode ?? '' }])
    )
    .otherwise(() => Routes.CONSUMER_LANDING);

  return shefLogoDisabled ? (
    <NoLinkWrapper color={color}>
      <Shef height={height} />
    </NoLinkWrapper>
  ) : (
    <StyledNavLink
      className='mx-0.5 rounded-sm focus:outline-none focus:ring-2 focus:ring-eggplant-300 focus:ring-offset-1'
      onClick={onClick}
      to={logoUrl}
      name='shef-logo'
      color={color}>
      <Shef height={height} />
    </StyledNavLink>
  );
};
